/**
 * @description Menu component
 * @file
 * @copyright © Copyright IBI Group., created 2019. All use, disclosure, and/or reproduction of this material is prohibited unless authorized in writing. All rights reserved.
 * @module components/Menu
 */

import React from 'react';
import PropTypes from 'prop-types';

/**
 * @description The Menu component.
 * @class
 * @extends {React.Component}
 */
class Menu extends React.Component {

    /**
     * @inheritdoc
     */
    constructor(props) {
        super(props);

        this.state = {
            showMenu: false
        };
    }

    /**
     * @inheritdoc
     */
    shouldComponentUpdate(nextProps, nextState) {
        return (
            this.state.showMenu !== nextState.showMenu ||
            this.props.delays !== nextProps.delays ||
            this.props.selectedDelays !== nextProps.selectedDelays
        );
    }

    /**
     * @inheritdoc
     */
    render() {
        const className = this.state.showMenu ? 'Menu-container expanded' : 'Menu-container';

        return (
            this.props.delays.length > 0 && (
                <div className={className}>
                    <div className="Menu">
                        <div className="Menu-title">
                            <button
                                type="button"
                                className="Menu-toggle-button"
                                onClick={this.handleMenuButtonClick.bind(this)}
                                aria-label="Expand delay menu">
                                <h2>Delays</h2>
                                <span className="material-icons">
                                    {this.state.showMenu ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}
                                </span>
                            </button>
                        </div>
                        <section className="Menu-section">
                            {this.props.delays.map((delay, index) => (
                                <div key={index} className="form-group">
                                    <label>
                                        <button
                                            onClick={this.handleDelayToggle.bind(this)}
                                            type="button"
                                            className="Menu-key-item"
                                            style={{
                                                background: `rgb(${delay.colour.red},${delay.colour.green},${delay.colour.blue})`
                                            }}
                                            value={index}
                                            aria-label={`Toggle delay band '${delay.description}'`}>
                                            <span
                                                className={
                                                    this.props.selectedDelays[index]
                                                        ? 'Menu-key-item-deselected material-icons hidden'
                                                        : 'Menu-key-item-deselected material-icons'
                                                }>
                                                clear
                                            </span>
                                        </button>
                                        {delay.description}
                                    </label>
                                </div>
                            ))}
                        </section>
                    </div>
                </div>
            )
        );
    }

    /**
     * @description Handles the toggling of delay bands.
     * @param {Object} event - The event.
     */
    handleDelayToggle(event) {
        const selectedDelays = [...this.props.selectedDelays],
            index = parseInt(event.currentTarget.value, 10);

        selectedDelays[index] = !selectedDelays[index];
        this.props.onChangeSelectedDelays(selectedDelays);
    }

    /**
     * @description Handles the click event of the menu button.
     */
    handleMenuButtonClick() {
        this.setState({
            showMenu: !this.state.showMenu
        });
    }
}

Menu.defaultProps = {
    delays: [],
    selectedDelays: [],

    onChangeSelectedDelays: () => null
};

Menu.propTypes = {
    delays: PropTypes.array.isRequired,
    selectedDelays: PropTypes.array.isRequired,

    onChangeSelectedDelays: PropTypes.func.isRequired
};

export default Menu;
